import { ConcreteEncodable } from "./ConcreteEncodable";

import { SystemMonitorEventSetImplEncoder } from "../../encoder/SystemMonitorEventSetImplEncoder";

import * as CubiqTS from "../../index";
import { SystemMonitorEventSet } from "../SystemMonitorEventSet";

export class SystemMonitorEventSetImpl extends ConcreteEncodable implements SystemMonitorEventSet {
  public static enType: string = "com.bcdfx.sysmon.impl.SystemMonitorEventSetImpl";

  /*FID=1*/
  public fQDN: string;
  /*FID=2*/
  public events: Array<CubiqTS.SystemMonitorEvent> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SystemMonitorEventSetImplEncoder.Instance;
    this.setEncodableType(SystemMonitorEventSetImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SystemMonitorEventSetImpl[" +
      "fQDN=" +
      this.fQDN +
      "events=" +
      this.events +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
